import { useEffect, useState } from 'react'
import Header from '../components/Header'
import axiosInstance from '../utils/axiosInstance';
import Session from "../utils/sessionStorage";
import nodata from "../assets/images/nodata.png";
import ConsentCheckModal from '../components/Home/ConcentCheckModal';
import Button from '../components/form/Button';
import ErrorModal from '../components/ErrorModal';

const CashBack = () => {
    const [cashBack, setCashBack] = useState([]);
    const [loading, setLoading] = useState(false);
    const [stats, setStats] = useState({});
    const [errorModal, setErrorModal] = useState({ open: false, message: "" });
    const [pagination, setPagination] = useState({
        current_page: 1,
        next_page_url: null,
        prev_page_url: null,
        total: 0,
        per_page: 0
    });
    const token = Session.get("token");

    async function getCashBack(url = null) {
        setLoading(true);
        try {
            const endpoint = url || "/api/v1/cashback-transactions";
            const response = await axiosInstance.get(endpoint,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }

            );
            if (response.status === 200) {
                const data_packages = response?.data?.cashback_transactions;
                setCashBack(data_packages);
                setPagination(response.data?.meta);
                setStats(response.data?.stats);
                console.log(" data ", response?.data?.cashback_transactions);
            }
        } catch (error) {
            console.log("errrorrr", error?.response?.data?.message)
            setErrorModal({ open: true, message: error?.response?.data?.message || "Failed to load cashback transactions" });
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        getCashBack();
    }, []);
    console.log("final data to map : ", cashBack)
    if (loading) {
        return <ConsentCheckModal />
    }
    if (cashBack?.length === 0) {
        return (
            <>
                <Header />
                <div className="flex flex-col justify-center  bg-white mt-[33px] h-44 rounded-lg mb-3">
                    <div className="mx-auto">
                        <img src={nodata} alt="no data" className="w-full h-full" />
                    </div>
                    <p className="font-poppins text-base font-medium text-accent-silver-900 text-center">
                        No Data Found
                    </p>
                </div>
            </>
        )
    }
    return (
        <div>
            <div className="bg-accent-grey-50 h-screen lg:w-[450px] w-full mx-auto flex flex-col">
                <Header />

                <div className="space-y-2.5 pt-6 mx-4 flex-1 pb-20">
                    {/* <h1 className="text-2xl font-bold text-center">No Package Data</h1> */}
                    <div className='rounded-[24px] bg-primary/5 space-y-3 p-4'>
                        <div className='flex justify-center bg-white items-center flex-col w-full py-6 rounded-[16px]'>
                            <h1 className='text-[17px] font-semibold text-primary'>
                                RM {stats?.total}
                            </h1>
                            <h1 className='text-[13px] font-[400] text-gray'>
                                Accumulated Cashback
                            </h1>

                        </div>
                        <div className='grid grid-cols-2 gap-3'>
                            <div className='flex justify-center bg-white items-center flex-col w-full py-4 rounded-[16px]'>
                                <h1 className='text-[17px] font-semibold text-primary'>
                                    RM {stats?.today}
                                </h1>
                                <h1 className='text-[13px] font-[400] text-gray'>
                                    Today Cashback
                                </h1>

                            </div>
                            <div className='flex justify-center bg-white items-center flex-col w-full py-4 rounded-[16px]'>
                                <h1 className='text-[17px] font-semibold text-primary'>
                                    RM {stats?.month}
                                </h1>
                                <h1 className='text-[13px] font-[400] text-gray'>
                                    Month Cashback
                                </h1>

                            </div>
                        </div>
                    </div>
                    {cashBack?.map((data, index) => {
                        return (
                            <div
                                key={index}
                                className=" px-4 py-6 flex flex-col gap-3 bg-primary/5 h-auto rounded-[24px]"
                            >
                                <div className='flex justify-between items-center'>
                                    <h3 className="text-primary font-semibold text-[17px]">
                                        {data?.send_from
                                        }

                                    </h3>
                                    <h3 className="text-primary font-semibold text-[17px]">
                                        {data?.package_name
                                        }

                                    </h3>
                                </div>
                                <div className="border-t-[1px] border-white"></div>
                                <div className="space-y-1.5">
                                    <div className="flex items-center gap-16 justify-between">
                                        <div>
                                            <p className="text-[13px] text-gray">Amount</p>
                                            <h3 className="text-[13px] font-semibold">
                                                {data?.amount}
                                            </h3>
                                        </div>
                                        <div>

                                            <p className="text-[13px] text-gray">
                                                Transaction Id
                                            </p>
                                            <h3 className="text-[13px] font-semibold">

                                                {data?.transaction_id ? data?.transaction_id : "N/A"}
                                            </h3>

                                        </div>
                                    </div>
                                </div>

                                <div className="flex items-center justify-between">
                                    <div>
                                        <p className="text-[13px] text-gray">Transaction date & Time</p>
                                        <h3 className="text-[13px] font-semibold">
                                            {data?.created_at}
                                        </h3>
                                    </div>
                                    <div className='py-1 px-3 rounded-full bg-[#00980D1A] text-[#00980D] text-[12px]'>
                                        {data?.status}
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>

                <div className="mt-auto bg-white p-4">
                    <div className="flex justify-between items-center">
                        <Button
                            eventAction={() => getCashBack(pagination.prev_page_url)}
                            disable={!pagination.prev_page_url}
                            classes={`${!pagination.prev_page_url ? "bg-primary" : ""} text-white py-3 gap-1`}
                            size={"md"}>
                            <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" />
                            </svg>
                            Prev
                        </Button>
                        <span className="text-sm font-medium">Page {pagination.current_page} of {Math.ceil(pagination.total / pagination.per_page)}</span>
                        <Button
                            eventAction={() => getCashBack(pagination.next_page_url)}
                            disable={!pagination.next_page_url}
                            size={"md"}
                            classes={`${!pagination.next_page_url ? "bg-primary" : ""} text-white py-3 gap-1`}>
                            Next
                            <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                        </svg>
                        </Button>
                    </div>
                </div>

            </div>

            {/* Error Modal */}
            {errorModal.open && (
                <ErrorModal
                    message={errorModal.message}
                    close={() => setErrorModal({ open: false, message: "" })}
                />
            )}
        </div>
    )
}

export default CashBack
